import { datepicker } from "./../../customplugins/datepicker.js";
import { Toaster } from "../../customplugins/toaster.js";
import { ClarityManager } from "../../core/clarity.js";

const today = new Date();
const maxDateObj = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
);

type SponsorRequest = {
    MemberId: string;
    DownMemberId: string;
    Series: string;
    TenantId: number;
};
const maxDate = maxDateObj.toISOString().split('T')[0];
document.getElementById("TxtDOB").addEventListener("click", function () {

});
new datepicker("#TxtDOB", {
    format: "dd/MM/yyyy",
    maxDate: maxDate
});
function getLabelText(inputId: string): string {
    const label = document.querySelector(`label[for="${inputId}"]`) as HTMLElement | null;
    return label?.innerText.replace(/\s+/g, " ").trim() || "Field";
}
function setMessage(element: HTMLElement, message: string, color: string): void {
    element.style.color = color;
    element.innerText = message;
}
function getErrorSpan(input: HTMLInputElement): HTMLElement | null {
    return input.closest(".floating-input")?.querySelector(".error-message") as HTMLElement;
}
async function checkSponsorId(): Promise<void> {
    const sponsorInput = document.getElementById("sponsorId") as HTMLInputElement | null;
    if (!sponsorInput) return;
    const errorSpan = getErrorSpan(sponsorInput);
    if (!errorSpan) return;
    const sponsorId = sponsorInput.value.trim();
    const labelText = getLabelText("sponsorId");

    // if (!sponsorId) {
    //     setMessage(errorSpan, `${labelText} is required`, "red");
    //     return;
    // }

    if(sponsorId?.trim()) {

        try {
            const response = await fetch('/CheckSponsorid', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    distributorIdno: sponsorId
                }),
            });
            const result = await response.json();
            if (result.status === true) {
                const sponsorRegidInput = document.getElementById("SponsorRegid") as HTMLInputElement | null;

                if (sponsorRegidInput && result.regID) {
                    sponsorRegidInput.value = result.regID;
                }
                const sponsornameInput = document.getElementById("sponsorname") as HTMLInputElement | null;
                const sponsor = document.getElementById("hdsponser") as HTMLElement;
                if (sponsornameInput && result.name) {
                    sponsornameInput.value = result.name;
                }

                ClarityManager.eventWithTags("CHECK_SPONSOR", {
                    RegistrationType: "WithoutPAN"
                });

                if (result.message_Key?.toUpperCase() === "SUCCESS") {

                    ClarityManager.tags({
                        SponsorStatus: "Success",
                        RegistrationType: "WithoutPAN",
                        Portal: "Distributor"
                    });
                    //setMessage(errorSpan, result.message_Key, "green");
                    sponsor.style.display = "block";
                }
                else {

                    ClarityManager.tags({
                        SponsorStatus: "Failed",
                        RegistrationType: "WithoutPAN",
                        Portal: "Distributor"
                    });

                    setMessage(errorSpan, result.message_Key, "red");
                    sponsor.style.display = "none";
                }
            } else {
                setMessage(errorSpan, result.message_Key, "red");
            }
        } catch (error) {
            console.error(error);
            setMessage(errorSpan, `Error validating ${labelText}`, "red");
        }
    }
}
async function checkPlacementId(): Promise<void> {
    const placementInput = document.getElementById("Placementid") as HTMLInputElement | null;
    const sponsorInput = document.getElementById("sponsorId") as HTMLInputElement | null;

    if (!placementInput || !sponsorInput) return;

    const errorSpan = getErrorSpan(placementInput);
    if (!errorSpan) return;

    const placementId = placementInput.value.trim();
    const sponsorId = sponsorInput.value.trim();
    const labelText = getLabelText("Placementid");

    // if (!placementId) {
    //     setMessage(errorSpan, `${labelText} is required`, "red");
    //     return;
    // }

    if (placementId?.trim()) {

        try {
            const response = await fetch('/CheckDownlineId', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    downmemberid: placementId,
                    memberid: sponsorId
                }),
            });

            const result = await response.json();

            if (result.status === true) {
                const placementRegidInput = document.getElementById("PlacementRegid") as HTMLInputElement | null;

                if (placementRegidInput && result.uplinerregid) {
                    placementRegidInput.value = result.uplinerregid;
                }
                const placementnameInput = document.getElementById("placementname") as HTMLInputElement | null;
                const placement = document.getElementById("hdplacement") as HTMLElement;
                if (placementnameInput && result.uplinername) {
                    placementnameInput.value = result.uplinername;
                }

                ClarityManager.eventWithTags("CHECK_PLACEMENT", {
                    RegistrationType: "WithoutPAN"
                });

                if (result.message_Key?.toUpperCase() === "SUCCESS") {

                    ClarityManager.tags({
                        PlacementStatus: "Success",
                        RegistrationType: "WithoutPAN",
                        Portal: "Distributor"
                    });

                    //setMessage(errorSpan, result.message_Key, "green");
                    placement.style.display = "block";
                }
                else {

                    ClarityManager.tags({
                        PlacementStatus: "Failed",
                        RegistrationType: "WithoutPAN",
                        Portal: "Distributor"
                    });

                    setMessage(errorSpan, result.message_Key, "red");
                }
            } else {
                setMessage(errorSpan, result.message_Key, "red");
            }

        } catch (error) {
            console.error(error);
            setMessage(errorSpan, `Error validating ${labelText}`, "red");
        }
    }
}
function clearErrors(): void {
    const elements = document.querySelectorAll<HTMLElement>(".clearerror");

    elements.forEach(el => {
        el.textContent = "";
    });
}
async function Getpincodedetails(): Promise<void> {
    const pincodeInput = document.getElementById("pincodeid") as HTMLInputElement | null;
    const errorSpan = document.getElementById("PincodeError") as HTMLElement | null;
    const stateidInput = document.getElementById("stateid") as HTMLInputElement | null;
    const statename = document.getElementById("statename") as HTMLInputElement | null;
    const select = document.getElementById("RegCityID") as HTMLSelectElement | null;
    if (!pincodeInput || !errorSpan) return;
    errorSpan.innerText = "";
    const pincodeid = pincodeInput.value.trim();
    if (!pincodeid) {
        errorSpan.style.color = "red";
        errorSpan.innerText = "Pincode  is required";
        return;
    }
    const tokenInput = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement | null;
    const token = tokenInput?.value ?? "";

    try {

        const pincodeId: any = {
            pincode: pincodeid,
        };
        const response = await fetch('/GetPincodedetails', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(pincodeId),
        });

        const result = await response.json();

        if (result != null && result.pincodeReports.length > 0) {

            if (result.pincodeReports[0].stateid) {
                stateidInput.value = result.pincodeReports[0].stateid;
            }

            //const cityidInput = document.getElementById("cityid") as HTMLInputElement | null;
            //if (cityidInput && result.cityid) {
            //    cityidInput.value = result.cityid;
            //}
            //const cityInput = document.getElementById("cityname") as HTMLInputElement | null;
            //if (cityInput && result.cityname) {
            //    cityInput.value = result.cityname;
            //}

            if (result.pincodeReports[0].statename) {
                statename.value = result.pincodeReports[0].statename;
            }

            clearErrors()

            if (select) {
                resetSelect(select, 'Select');

                result.pincodeReports.forEach((city, index) => {
                    const option = document.createElement("option");
                    option.value = city.cityid.toString();
                    option.textContent = city.cityname;

                    if (index === 0) {
                        option.selected = true;
                    }

                    select.appendChild(option);
                });
            }

        }
        else {
            stateidInput.value = "";
            statename.value = "";
            resetSelect(select, 'Select City');
            errorSpan.style.color = "red";
            errorSpan.innerText = "Invalid Pincode";
        }
    } catch (error) {
        stateidInput.value = "";
        statename.value = "";
        resetSelect(select, 'Select City');
        errorSpan.style.color = "red";
        errorSpan.style.color = "red";
        errorSpan.innerText = "Incorrect Pincode";

    }
}
function resetSelect(select: HTMLSelectElement, placeholder: string) {
    select.innerHTML = "";

    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.text = placeholder;
    defaultOption.disabled = true;
    defaultOption.selected = true;

    select.appendChild(defaultOption);
}
function resetSelectnodisabled(select: HTMLSelectElement, placeholder: string) {
    select.innerHTML = "";

    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.text = placeholder;
    defaultOption.disabled = false;
    defaultOption.selected = true;

    select.appendChild(defaultOption);
}
document.addEventListener("DOMContentLoaded", () => {

    ClarityManager.eventWithTags("REGISTRATION_SUBMITTED", {
        RegistrationType: "WithoutPAN"
    });
    const hiddenInput = document.getElementById("hdnviewbagvalue") as HTMLInputElement | null;

    const sponsorInput = document.getElementById("sponsorId") as HTMLInputElement | null;
    if (sponsorInput) {
        sponsorInput.addEventListener("blur", checkSponsorId);
        if (sponsorInput.value) {
            // sponsorInput.readOnly = true;
            checkSponsorId();
        }

    }
    const placementInput = document.getElementById("Placementid") as HTMLInputElement | null;
    if (placementInput) {
        placementInput.addEventListener("blur", checkPlacementId);
    }
    const pincodeInput = document.getElementById("pincodeid") as HTMLInputElement | null;
    if (pincodeInput) {
        pincodeInput.addEventListener("blur", Getpincodedetails);
    }

    const uplineser = document.getElementById("uplinervalue") as HTMLInputElement;


    GetNomineeDetails()
    const SpserIDselect = document.querySelector<HTMLSelectElement>("#SpserID");

    SpserIDselect?.addEventListener("change", async () => {
        const value = SpserIDselect.value;
        //console.log(value);
        uplineser.value = value;
        const PlacementRegid = document.getElementById("Placementid") as HTMLInputElement;
        const sponsorId = document.getElementById("sponsorId") as HTMLInputElement;
        if (PlacementRegid.value && sponsorId.value) {
            let checksponcer: SponsorRequest = {
                MemberId: sponsorId.value,
                DownMemberId: PlacementRegid.value,
                Series: value,
                TenantId: 0
            };

            checkSponsor(checksponcer); // ✅ call FUNCTION, not object

        }


    });

    const emailInputs = document.querySelectorAll<HTMLInputElement>(
        "input[data-email]"
    );

    const validateEmail = (input: HTMLInputElement): boolean => {
        const errorSpan = input
            .closest(".floating-input")
            ?.querySelector(".error-message");

        const value = input.value.trim();

        if (input.dataset.required && value === "") {
            if (errorSpan) {
                errorSpan.textContent = `${input.dataset.required} is required`;
            }

            return false;
        }
        if (value !== "") {

            const emailRegex =
                /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

            if (!emailRegex.test(value)) {

                if (errorSpan) {
                    errorSpan.textContent = "Enter a valid email address";
                }

                return false;
            }
        }
        if (
            input.dataset.minlength &&
            value.length < parseInt(input.dataset.minlength)
        ) {
            if (errorSpan) {
                errorSpan.textContent =
                    `Email must be at least ${input.dataset.minlength} characters`;
            }

            return false;
        }

        if (errorSpan) {
            errorSpan.textContent = "";
        }

        return true;
    };
    emailInputs.forEach((input) => {

        input.addEventListener("input", () => {
            validateEmail(input);
        });
        input.addEventListener("blur", () => {
            validateEmail(input);
        });
    });
    //  document.getElementById("myForm")?.addEventListener("submit", function (e) {
    //     let isValid = true;
    //     if (!validateRequiredFields()) {
    //         isValid = false;
    //     }
    //     emailInputs.forEach((input) => {
    //         if (!validateEmail(input)) {
    //             isValid = false;
    //         }
    //     });
    //     if (!validateMobile()) {
    //         isValid = false;
    //     }
    //     const termsCheckbox = document.getElementById("chkTerms") as HTMLInputElement | null;
    //     const termsError = document.getElementById("termserror");
    //     if (termsCheckbox && !termsCheckbox.checked) {
    //         if (termsError) {
    //             termsError.textContent = "Please accept the Terms and Conditions";
    //         }
    //         isValid = false;
    //     } else if (termsError) {
    //         termsError.textContent = "";
    //     }
    //     if (!isValid) {
    //         e.preventDefault();
    //         return false;
    //     }
    //     return true;
    // });


    // document.getElementById("myForm")?.addEventListener("submit", function (e) {
    //     let isValid = true;


    //     const nameInput = document.getElementById("txtname") as HTMLInputElement;
    //     if (nameInput && !nameInput.value.trim()) {
    //         const error = nameInput
    //             .closest(".floating-input")
    //             ?.querySelector(".error-message");

    //         if (error) error.textContent = "Please enter your name";
    //         isValid = false;
    //     } else if (nameInput) {
    //         const error = nameInput
    //             .closest(".floating-input")
    //             ?.querySelector(".error-message");

    //         if (error) error.textContent = "";
    //     }


    //     if (!validateMobile()) {
    //         isValid = false;
    //     }


    //     const termsCheckbox = document.getElementById("chkTerms") as HTMLInputElement | null;;
    //     const termsError = document.getElementById("termserror");

    //     if (termsCheckbox && !termsCheckbox.checked) {
    //         if (termsError) {
    //             termsError.textContent =
    //                 "Please accept the Terms and Conditions";
    //         }
    //         isValid = false;
    //     } else if (termsError) {
    //         termsError.textContent = "";
    //     }

    //     if (!isValid) {
    //         e.preventDefault();
    //     }
    // });

    function validateName() {
        const name = document.getElementById("txtname") as HTMLInputElement;
        const error = name.closest(".floating-input").querySelector(".error-message");

        if (name.value.trim() === "") {
            error.textContent = "Please enter your name";
            return false;
        }

        error.textContent = "";
        return true;
    }

    function validateMobile() {
        const mobile = document.getElementById("REGMobile") as HTMLInputElement;
        const error = mobile.closest(".floating-input").querySelector(".error-message");
        const number = mobile.value.trim();

        if (!/^\d{10}$/.test(number)) {
            error.textContent = "Please enter a valid 10-digit mobile number";
            return false;
        }

        error.textContent = "";
        (document.getElementById("VerifyMobile") as HTMLInputElement).value = number;
        return true;
    }

 
    document.getElementById("txtname").addEventListener("input", validateName);
    document.getElementById("REGMobile").addEventListener("input", function () {
        const error = this.closest(".floating-input").querySelector(".error-message");
        if (error) error.textContent = "";
    });

 
    document.getElementById("myForm").addEventListener("submit", function (e) {
        const isNameValid = validateName();
        const isMobileValid = validateMobile();

        if (!isNameValid || !isMobileValid) {
            e.preventDefault();
        }
    });


    const passwordElement =
        document.getElementById("registrationPassword");

    const toggleButton =
        document.getElementById("toggleRegistrationPassword");

    const eyeIcon =
        document.getElementById("passwordEyeIcon");

    if (!passwordElement || !toggleButton) {
        return;
    }

    const password = passwordElement.dataset.password || "";

    let isVisible = false;

    toggleButton.addEventListener("click", function () {
        isVisible = !isVisible;

        if (isVisible) {
            passwordElement.textContent = password;
            toggleButton.title = "Hide Password";
            toggleButton.setAttribute(
                "aria-label",
                "Hide Password"
            );
            eyeIcon.innerHTML = `
                    <path d="M3 3l18 18"></path>
                    <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8"></path>
                    <path d="M9.9 5.1A10.8 10.8 0 0 1 12 5c6.5 0 10 7 10 7a18.3 18.3 0 0 1-3.1 4.1"></path>
                    <path d="M6.6 6.6C3.8 8.3 2 12 2 12s3.5 7 10 7c1.8 0 3.4-.5 4.7-1.2"></path>
                `;
        }
        else {

            passwordElement.textContent = "********";

            toggleButton.title = "View Password";
            toggleButton.setAttribute(
                "aria-label",
                "View Password"
            );
            eyeIcon.innerHTML = `
                    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                `;
        }
    });
});
function validateMobile(): boolean {


    const value = VmobileInput?.value?.trim();
    var isMobileByPass = document.getElementById("hdfIsMobileByPass") as HTMLInputElement;

    if (isMobileByPass.value == '1') {
        VmobileInput.value = mobileInput.value;
    }

    if (isMobileByPass.value != '1' && (!value && mobileInput.value != "" && mobileInput.value.length == 10)) {
        Toaster.error("Please verify mobile number");
        return false;
    }

    return true;
}
const VmobileInput = document.getElementById("VerifyMobile") as HTMLInputElement;
const mobileInput = document.getElementById("REGMobile") as HTMLInputElement;
if (mobileInput) {
    mobileInput.addEventListener("keydown", (event) => {
        restrictMobileInput(event, mobileInput);
    });
    mobileInput.addEventListener("paste", (event) => {
        event.preventDefault();
        const pastedText = event.clipboardData
            ?.getData("text")
            .replace(/\D/g, "")
            .slice(0, 10) ?? "";

        if (pastedText && /^[6-9]/.test(pastedText)) {
            mobileInput.value = pastedText;
        }
    });
}
const sendOtpBtn = document.getElementById("sendOtpBtn") as HTMLButtonElement;
const otpSection = document.getElementById("otpSection") as HTMLElement;
const otpInput = document.getElementById("otpInput") as HTMLInputElement;
const verifyOtpBtn = document.getElementById("verifyOtpBtn") as HTMLButtonElement;
const resendOtpBtn = document.getElementById("resendOtpBtn") as HTMLButtonElement;
let currentMobile: string = "";
//sendOtpBtn.style.display = "none";
//otpInput.value = "12345";
function isValidMobile(mobile: string): boolean {
    return /^[6-9]\d{9}$/.test(mobile);
}
async function checkSponsor(data: SponsorRequest) {
    const response = await fetch('/CheckSponsorPlacement', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });

    const result = await response.json();
    const spserSelect = document.getElementById("SpserID") as HTMLSelectElement;
    if (result.status == true) {
        if (result.messageKey.toUpperCase() != "SUCCESS") {
            //setMessage(errorSpan, result.message_Key, "red");
            Toaster.error(result.messageKey);
            spserSelect.value = "";
            return
        }
    }
    //console.log(result);
}
async function GetNomineeDetails() {
    const response = await fetch('/GetNomineeDetails', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
    });

    const result = await response.json();
    if (result.status == true) {
        const select = document.getElementById("RegRelation") as HTMLSelectElement | null;
        if (select) {
            resetSelectnodisabled(select, 'Select');

            result.nomineeReport.forEach((relation, index) => {
                const option = document.createElement("option");
                option.value = relation.relation_name.toString();
                option.textContent = relation.relation_name;

                //if (index === 0) {
                //    option.selected = true;
                //}

                select.appendChild(option);
            });
        }
    }
    //console.log(result);
}
sendOtpBtn.addEventListener("click", async () => {
    const nameInput = document.getElementById("txtname") as HTMLInputElement;
    const name = nameInput.value.trim();
    const enteredMobile = mobileInput.value.trim();
    if (!isValidMobile(enteredMobile)) {
        Toaster.error("Enter valid 10-digit mobile number");
        return;
    }

    ClarityManager.eventWithTags("OTP_SENT", {
        RegistrationType: "WithoutPAN"
    });

    try {
        sendOtpBtn.disabled = true;

        const response = await fetch(`/GeneralRegSendOtp?Name=${encodeURIComponent(name)}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                Mobileno: enteredMobile,
                Regid: 0,
                ModuleType: "Registration"
            })
        });

        const result = await response.json();

        if (result.success) {

            ClarityManager.tags({
                OTPStatus: "Sent",
                RegistrationType: "WithoutPAN",
                Portal: "Distributor"
            });

            currentMobile = enteredMobile;
            otpSection.style.display = "block";
            sendOtpBtn.style.display = "none";

            Toaster.success(`${result.message}`);

            startResendCooldown();
        } else {

            ClarityManager.tags({
                OTPStatus: "Failed",
                RegistrationType: "WithoutPAN",
                Portal: "Distributor"
            });

            Toaster.error(result.message || "Failed to send OTP");
        }

    } catch (error) {

        ClarityManager.tags({
            OTPStatus: "Error sending OTP",
            RegistrationType: "WithoutPAN",
            Portal: "Distributor"
        });

        console.error(error);
        Toaster.error("Error sending OTP");
    } finally {
        sendOtpBtn.disabled = false;
    }
});
var ismobilecheck = false;
verifyOtpBtn.addEventListener("click", async () => {

    const otp = otpInput.value.trim();
    if (otp.length !== 6) {
        Toaster.error("Enter valid OTP");
        return;
    }

    ClarityManager.eventWithTags("OTP_VERIFIED", {
        RegistrationType: "WithoutPAN"
    });

    try {
        verifyOtpBtn.disabled = true;
        const response = await fetch("/VerifyOtp", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                Otp: otp,
                MobileNo: currentMobile
            })
        });
        const result = await response.json();

        if (result.success) {

            ClarityManager.tags({
                OTPStatus: "Verified",
                RegistrationType: "WithoutPAN",
                Portal: "Distributor"
            });

            otpSection.style.display = "none";
            ismobilecheck = true;
            sendOtpBtn.style.display = "none"
            VmobileInput.value = currentMobile
            mobileInput.value = currentMobile;
            mobileInput.disabled = true;
        } else {
            ClarityManager.tags({
                OTPStatus: "Failed",
                RegistrationType: "WithoutPAN",
                Portal: "Distributor"
            });
            Toaster.error(result.message || "Invalid OTP");
            resendOtpBtn.style.display = "inline-block";
        }
    } catch (error) {
        console.error(error);
        Toaster.error("OTP verification failed");
    } finally {
        verifyOtpBtn.disabled = false;
    }
});
resendOtpBtn.addEventListener("click", async () => {
    if (!currentMobile) {
        Toaster.error("Mobile missing");
        return;
    }
    try {
        resendOtpBtn.disabled = true;

        const response = await fetch("/GeneralRegSendOtp", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                Mobileno: currentMobile,
                Regid: 0,
                ModuleType: "Registration"
            })
        });

        const result = await response.json();

        if (result.success) {

            ClarityManager.tags({
                OTPStatus: "ResendOTP",
                RegistrationType: "WithPAN",
                Portal: "Distributor"
            });

            Toaster.success(`${result.message}`);

            otpInput.value = "";
            startResendCooldown();
        } else {
            Toaster.error(result.message || "Resend failed");
        }

    } catch (error) {
        console.error(error);
    } finally {
        resendOtpBtn.disabled = false;
    }
});
function startResendCooldown(): void {
    let seconds = 30;

    resendOtpBtn.style.display = "inline-block";
    resendOtpBtn.disabled = true;

    const interval = setInterval(() => {
        resendOtpBtn.textContent = `Resend OTP (${seconds}s)`;
        seconds--;

        if (seconds < 0) {
            clearInterval(interval);
            resendOtpBtn.disabled = false;
            resendOtpBtn.textContent = "Resend OTP";
        }
    }, 1000);
}
// function validateRequiredFields(): boolean {
//     let isValid = true;

//     const requiredInputs = document.querySelectorAll<
//         HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
//     >("[data-required]");

//     requiredInputs.forEach((input) => {
//         if (input instanceof HTMLInputElement && input.type === "checkbox") {
//             if (!input.checked) {
//                 const errorSpan = input
//                     .closest(".form-check")
//                     ?.parentElement
//                     ?.querySelector(".error-message") as HTMLElement | null;

//                 if (errorSpan) {
//                     errorSpan.textContent =
//                         `${input.dataset.required || "This field"} is required`;
//                 }

//                 isValid = false;
//             }

//             return;
//         }
//         if (input.type === "hidden") {
//             return;
//         }
//         if (input.offsetParent === null) {
//             return;
//         }

//         const value = input.value?.trim() ?? "";

//         const errorSpan = input
//             .closest(".floating-input")
//             ?.querySelector(".error-message") as HTMLElement | null;

//         const fieldName = input.dataset.required || "Field";

//         if (input instanceof HTMLSelectElement) {

//             if (!value || value === "Select") {
//                 if (errorSpan) {
//                     errorSpan.textContent = `${fieldName} is required`;
//                     errorSpan.style.color = "red";
//                 }

//                 isValid = false;
//                 return;
//             }
//         }

//         if (!value) {
//             if (errorSpan) {
//                 errorSpan.textContent = `${fieldName} is required`;
//                 errorSpan.style.color = "red";
//             }

//             isValid = false;
//             return;
//         }

//         if (errorSpan) {
//             errorSpan.textContent = "";
//         }
//     });

//     return isValid;
// }

function restrictMobileInput(event: KeyboardEvent, input: HTMLInputElement): void {
    const key = event.key;
    if (
        key === "Backspace" ||
        key === "Delete" ||
        key === "ArrowLeft" ||
        key === "ArrowRight" ||
        key === "Tab"
    ) {
        return;
    }
    if (event.ctrlKey || event.metaKey) {
        return;
    }
    if (!/^\d$/.test(key)) {
        event.preventDefault();
        return;
    }
    if (input.value.length === 0 && !/^[6-9]$/.test(key)) {
        event.preventDefault();
        return;
    }
    if (input.value.length >= 10) {
        event.preventDefault();
        return;
    }
}
